import { code } from "@spscommerce/utils";

export const SpsKeyValueListExamples = {
    stacked: {
        label: "Stacked",
        examples: {
            stacked: {
                template: code`
                    <sps-key-value-list>
                        <sps-key-value-list-item key="Buying From">
                            75 Companies
                            <span class="font-weight-light d-block">38 of 75 Operational</span>
                        </sps-key-value-list-item>
                        <sps-key-value-list-item key="Some Other Key">Its Value</sps-key-value-list-item>
                    </sps-key-value-list>
                `
            }
        }
    },
    inline: {
        label: "Inline",
        examples: {
            inline: {
                template: code`
                    <sps-key-value-list inline>
                        <sps-key-value-list-item key="Title">Sub copy goes here</sps-key-value-list-item>
                        <sps-key-value-list-item key="Long Title">Sub copy</sps-key-value-list-item>
                        <sps-key-value-list-item key="Tags">
                            <sps-tag kind="info" class="mr-1 mb-1">Tag</sps-tag>
                            <sps-tag kind="info" class="mr-1 mb-1">Another Tag</sps-tag>
                            <sps-tag kind="info" class="mr-1 mb-1">Taggart McTaggerson</sps-tag>
                            <sps-tag kind="info" class="mr-1 mb-1">Taggle Rock</sps-tag>
                            <sps-tag kind="info" class="mr-1 mb-1">A Tag On Titan</sps-tag>
                            <sps-tag kind="info" class="mr-1 mb-1">bröther may i have some tägs</sps-tag>
                            <sps-tag kind="info" class="mr-1 mb-1">Tag Me Up, Tag Me Down</sps-tag>
                        </sps-key-value-list-item>
                    </sps-key-value-list>
                `
            }
        }
    }
};
